import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-privacy-content',
    templateUrl: './privacy-content.component.html',
    styleUrls: ['./privacy-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrivacyContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
